// src/pages/AssinaturaSucesso.jsx
import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PLAN_LABEL = {
  basic: "Basic",
  pro: "Pro",
  enterprise: "Enterprise",
};

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function AssinaturaSucesso() {
  const nav = useNavigate();
  const q = useQuery();
  const planParam = (q.get("plan") || "").trim().toLowerCase();
  const planName = PLAN_LABEL[planParam] || "seu plano";

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.iconWrap}>
          <div style={s.checkIcon}>✓</div>
        </div>

        <h1 style={s.title}>Assinatura iniciada!</h1>
        <p style={s.subtitle}>
          Obrigado por escolher o <strong>{planName}</strong>. Assim que o pagamento for
          confirmado pela Stripe, sua assinatura será ativada automaticamente.
        </p>

        <div style={s.infoBox}>
          <p style={s.infoTitle}>O que acontece agora?</p>
          <ul style={s.list}>
            <li>Confirmamos o pagamento com segurança.</li>
            <li>Aplicamos o plano à sua conta.</li>
            <li>Você poderá usar os recursos do {planName} imediatamente após a confirmação.</li>
          </ul>
          <p style={{ marginTop: 8, opacity: 0.8 }}>
            Se esta aba foi aberta automaticamente, você pode fechá-la com segurança.
          </p>
        </div>

        <div style={s.actions}>
          <button style={s.primary} onClick={() => nav("/")}>
            Ir para o painel
          </button>
          <button style={s.secondary} onClick={() => nav("/assinatura")}>
            Gerenciar assinatura
          </button>
        </div>

        <p style={s.help}>
          Precisa de ajuda? Fale com a gente no WhatsApp:
          {" "}
          <a href="https://wa.me/5511976299276" target="_blank" rel="noopener noreferrer">
            (11) 97629-9276
          </a>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: "40px 20px",
    background: "linear-gradient(180deg, #f6f9fe 0%, #fff 100%)",
    fontFamily:
      "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial",
    color: "#1F1A1A",
  },
  card: {
    width: "100%",
    maxWidth: 640,
    background: "#fff",
    border: "1px solid #e6ecf5",
    borderRadius: 20,
    boxShadow: "0 10px 30px rgba(58,121,237,.08)",
    padding: 28,
    textAlign: "center",
  },
  iconWrap: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: "rgba(58,121,237,0.1)",
    marginBottom: 12,
  },
  checkIcon: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "#3A79ED",
    color: "#fff",
    display: "grid",
    placeItems: "center",
    fontWeight: 800,
    fontSize: 22,
    boxShadow: "0 6px 14px rgba(58,121,237,.3)",
  },
  title: { fontSize: 28, fontWeight: 800, margin: "10px 0 6px" },
  subtitle: { fontSize: 16, opacity: 0.9, marginBottom: 18 },
  infoBox: {
    textAlign: "left",
    background: "#f7fbff",
    border: "1px solid #e6f0ff",
    borderRadius: 14,
    padding: 16,
    margin: "0 auto 18px",
  },
  infoTitle: { fontWeight: 700, marginBottom: 8 },
  list: { margin: 0, paddingLeft: 18, lineHeight: 1.7 },
  actions: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: 8,
  },
  primary: {
    border: "none",
    borderRadius: 12,
    padding: "12px 18px",
    fontWeight: 700,
    fontSize: 16,
    background: "#3A79ED",
    color: "#fff",
    cursor: "pointer",
  },
  secondary: {
    border: "1px solid #d9e4ff",
    borderRadius: 12,
    padding: "12px 18px",
    fontWeight: 700,
    fontSize: 16,
    background: "#fff",
    color: "#3A79ED",
    cursor: "pointer",
  },
  help: { marginTop: 18, fontSize: 14, opacity: 0.8 },
};
